import { render } from "./PromoCode.vue?vue&type=template&id=1d1b22a6"
import script from "./PromoCode.vue?vue&type=script&lang=js"
export * from "./PromoCode.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__